import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"
import TableMockImage from "./MockImages"

const NoFinancialStatement = () => (
  <div className="flex flex-col gap-6 relative w-full h-full">
    <TableMockImage />
    <div className="absolute h-full gap-4 mx-auto left-0 right-0 flex flex-col items-center justify-center text-center">
      <span className="text-base break-words" style={{ maxWidth: "80%" }}>
        We do not yet have financial data for this project.
      </span>
      <LinkButton href="/projects" variant="solid">
        Explore other projects
      </LinkButton>
    </div>
  </div>
)

export default NoFinancialStatement
